import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import TraitForm from './TraitForm';
import { showTraitApi, updateTraitApi, clearEditedTrait } from './traitSlice';

function TraitUpdate() {
    const { id } = useParams();
    const { editedModel: initialValues } = useSelector((state) => state.heroSaga.trait);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const type = searchParams.get('type');

    const formSubmit = async (values) => {
        dispatch(updateTraitApi({ navigate, type, values, id }));
    };

    useEffect(() => {
        dispatch(showTraitApi({ navigate, type, id }));

        return () => dispatch(clearEditedTrait());
    }, []);

    return (
        <TraitForm
            initialValues={initialValues}
            type={type}
            formSubmit={formSubmit}
        />
    );
}

export default TraitUpdate;
